export default __webpack_public_path__ + "static/media/girl1.6884bb72.svg";